import "./WebPresentation.scss";
import {
    ArrowRight,
    Code2,
    Globe,
    Laptop,
    Lightbulb,
    Rocket,
    Zap,
} from "lucide-react";
import SitePresentationWeb from "../../Components/SitePresentationWeb/SitePresentationWeb";
import logo from "../../Images/logo.png"
import {useTranslation} from "react-i18next";
import {DiscordMember} from "../../types";
import {discordUrl} from "../../Global";

type website = {
    image: string;
    name: string;
    description: string;
    color: string;
};

const websiteData: website[] = [
    {
        image: logo,
        name: "EnderClub (this)",
        description:
            "EnderClub è un network dove un team si unisce per aiutare i tuoi progetti a prendere il volo.",
        color: "#6a00c5",
    }
];

const steps = [
    {
        id: "01",
        icon: Lightbulb,
    },
    {
        id: "02",
        icon: Laptop,
    },
    {
        id: "03",
        icon: Code2,
    },
    {
        id: "04",
        icon: Rocket,
    },
];

interface WebPresentationProps {
    staff: DiscordMember[] | [];
}



export default function WebPresentation({ staff }: WebPresentationProps) {
    const { t } = useTranslation();
    let webDevelopers: DiscordMember[] | [] = [];

    webDevelopers = staff.filter((member) =>
        member.roles.some((role) => role.id === "1425534503497240626")
    );

    console.log(staff)

    return (
        <section className="web-dev">
            {/* ===== HERO ===== */}

            <div className="web-dev__hero">
                <div className="web-dev__hero-container">
                    {/* Left */}
                    <div className="web-dev__hero-content">
                        <h1 className="web-dev__title">
                            {t("web.title.up")}
                            <br />
                            {t("web.title.down")}<span>{t("web.title.bold")}</span>
                        </h1>
                        <p className="web-dev__description">
                            {t("web.subtitle")}
                        </p>
                        <div className="web-dev__actions">
                            <a href={discordUrl} target="_blank" className="web-dev__button" rel="noreferrer">
                                {t("web.preventive")}
                                <ArrowRight size={18} />
                            </a>
                            {websiteData.length > 0 && (
                                <a href="#portfolio" className="web-dev__button web-dev__button--secondary">
                                    {t("web.lookWorks")}
                                </a>
                            )}
                        </div>
                    </div>

                    <div className="web-dev__presentation">
                        <SitePresentationWeb/>
                    </div>
                </div>
            </div>

            {/* ===== STEP ===== */}
            <div className="web-dev__steps">
                <div className="web-dev__steps-container">
                    <header className="web-dev__steps-header">
                        <h2>{t(`web.develop.title`)}</h2>
                        <p>{t(`web.develop.subtitle`)}</p>
                    </header>

                    <div className="web-dev__steps-grid">
                        {steps.map((step, index) => {
                            const Icon = step.icon;
                            return (
                                <div className="web-dev__step" key={step.id}>
                                    <div className="web-dev__step-icon">
                                        <Icon size={24} />
                                    </div>
                                    <h3 className="web-dev__step-title">{t(`web.develop.card.${step.id}.title`)}</h3>
                                    <p className="web-dev__step-description">{t(`web.develop.card.${step.id}.subtitle`)}</p>
                                    {index < steps.length - 1 && (
                                        <div className="web-dev__step-connector">
                                            <Zap size={14} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* ===== TEAM ===== */}
            {webDevelopers.length > 0 && (
                <div className="web-dev__team">
                <div className="web-dev__team-container">
                    <header className="web-dev__team-header">
                        <h2>{t(`web.employees.title`)}</h2>
                        <p>{t(`web.employees.subtitle`)}</p>
                    </header>

                    <div className="web-dev__team-grid">
                        {webDevelopers.map((dev) => (
                            <a
                                key={dev.id}
                                target="_blank"
                                href={dev.avatar}
                                rel="noopener noreferrer"
                                className="web-dev__team-card"
                            >
                                <div className="web-dev__team-avatar">
                                    <img src={dev.avatar} alt={dev.username} />
                                    <div className={`web-dev__team-status web-dev__team-status_${dev.online}`} />
                                </div>
                                <h3>{dev.username}</h3>
                                <span>Web Developer</span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            )}

            {/* ===== PORTFOLIO ===== */}
            {websiteData.length > 0 && (
                <div className="web-dev__portfolio" id="portfolio">
                <div className="web-dev__portfolio-container">
                    <header className="web-dev__portfolio-header">
                        <h2>{t(`web.works.title`)}</h2>
                        <p>{t(`web.works.subtitle`)}</p>
                    </header>


                        <div className="web-dev__portfolio-grid">
                            {websiteData.map((website) => (
                                <ClientCard
                                    website={website}
                                />
                            ))}
                        </div>

                </div>
            </div>
            )}
        </section>
    );
}

function ClientCard({website}: { website: website; }) {

    return (
        <article
            className="clients-card"
            style={{ "--server-color": website.color } as React.CSSProperties}
            role="button"
            tabIndex={0}
        >
            <div className="clients-card_container_info">
                <div className="clients-card__image">
                    {website.image && (
                        <img src={website.image} alt={website.name} loading="lazy" />
                    )}
                </div>

                <div className="clients-card__content">
                    <h3 style={{ color: website.color }}>
                        {website.name}
                        <div className="clients-card__url"><Globe/></div>
                    </h3>
                    <p>{website.description}</p>
                </div>
            </div>

            <div className="clients-card__footer">
                <p>by STambu09</p>
            </div>
        </article>
    );
}


